import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import SettingsNav from '../../components/settingsNav'

const ChangeLog = ({ match }) => {
  // Other Variables

  useEffect(() => {
    document.title = "Changelog | WillowBMS"
  }, [])

  return (
    <div className="page-wrapper">
      <div className="container-xl">
        <div className="page-header d-print-none">
          <div className="row align-items-center">
            <div className="col">
              <h2 className="page-title">
                Settings
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row gx-lg-4">
            <SettingsNav />
            <div className="col-lg-9">
              <div className="card card-md">
                <div className="card-body">
                  <div className="markdown">
                    <div>
                      <div className="d-flex mb-3">
                        <h1 className="m-0">Changelog</h1>
                      </div>
                    </div>
                    <div className="mb-4">
                      <div className="mb-2">
                        <span className="badge bg-blue-lt">v0.0.2-alpha</span> –
                        <span className="text-muted">TBD</span>
                      </div>
                      <p>Alpha release of WillowBMS v0.0.2! Lots more coming soon though 😁</p>
                      <ul>
                        <li>TBD</li>
                      </ul>
                    </div>
                    <div className="mb-4">
                      <div className="mb-2">
                        <span className="badge bg-blue-lt">v0.0.1-alpha</span> –
                        <span className="text-muted">January 26, 2022</span>
                      </div>
                      <p>Initial release of WillowBMS v0.0.1!</p>
                      <ul>
                        <li>Client Management</li>
                        <li>Use Profile Management</li>
                        <li>System Settings - General</li>
                        <li>System Settings - Email</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChangeLog